import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../components/atoms/Spinner/Spinner';
import useAuthorization from '../hooks/useAuthorization';

interface ProtectedRouteProps {
  roles: string[];
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles, element }) => {
  const { isAuthorized, status } = useAuthorization({ requiredRoles: roles });
  const [isTokenRefreshing, setIsTokenRefreshing] = useState(false);

  const currentLocation = useLocation();

  useEffect(() => {
    const handleTokenRefreshStart = () => setIsTokenRefreshing(true);
    const handleTokenRefreshEnd = () => setIsTokenRefreshing(false);

    window.addEventListener('token-refresh-start', handleTokenRefreshStart);
    window.addEventListener('token-refresh-end', handleTokenRefreshEnd);

    return () => {
      window.removeEventListener(
        'token-refresh-start',
        handleTokenRefreshStart
      );
      window.removeEventListener('token-refresh-end', handleTokenRefreshEnd);
    };
  }, []);

  if (status === 'loading' || status === 'idle' || isTokenRefreshing) {
    return <Spinner />;
  }

  return isAuthorized ? (
    <>{element}</>
  ) : (
    <Navigate to="/not-authorized" state={{ from: currentLocation }} replace />
  );
};

export default ProtectedRoute;
